export let Action = /*#__PURE__*/function (Action) {
  Action["Push"] = "PUSH";
  Action["Pop"] = "POP";
  Action["Replace"] = "REPLACE";
  return Action;
}({});
//# sourceMappingURL=widget.js.map